import React from 'react';
import LegalPage from './LegalPage';

export default function CommunityGuidelines() {
  return <LegalPage pageKey="communityGuidelines" />;
}
